const AnalystData = [
  ['86Research Limited', 'Xiaoyan Wang', 'xiaoyan@86research.com'],
  ['Bank of America Merrill Lynch', 'Lei Zhang', 'Lei.zhang22@bofa.com'],
  ['Bank of China International', 'Michael Meng', 'Michael.meng@bocigroup.com'],
  ['Benchmark Company LLC', 'Fawne Jiang', 'fjiang@benchmarkcompany.com'],
  ['Bernstein Research', 'Robin Zhu', 'robin.zhu@bernstein.com'],
  ['BOCOM International Holdings', 'Connie Gu', 'connie.gu@bocomgroup.com'],
  ['CCB International (Holdings) Limited', 'Cathy Chan', 'cathychan@ccbintl.com'],
  ['China International Capital Corporation', 'Yang Bai', 'yang3.bai@cicc.com.cn'],
  ['China Merchants Securities (Hong Kong)', 'Tommy Wong', 'tommywong@cmschina.com.hk'],
  ['China Renaissance Securities (US)', 'Ella Ji', 'ellaji@chinarenaissance.com'],
  ['China Securities Co., Ltd', 'Shifeng Cui', 'cuishifeng@csc.com.cn'],
  ['Citic Securities', 'Ya Jiang', 'jiangya@citics.com'],
  ['Citigroup Global Markets Asia Limited', 'Alicia Yap', 'alicia.yap@investmentresearch.citi.com'],
  ['CLSA Limited', 'Elinor Leung', 'elinor.leung@clsa.com'],
  ['CMB International Capital Corp Ltd', 'Saiyi He', 'hesaiyi@cmbi.com.hk'],
  ['UBS Group AG', 'Kenneth Fong', 'kenneth-kc.fong@ubs.com'],
  ['Daiwa Capital Markets Hong Kong Limited', 'John Choi', 'john.choi@hk.daiwacm.com'],
  ['First Shanghai Securities Ltd.', 'Simon Luo', 'simon.luo@firstshanghai.com.hk'],
  ['GF Securities', 'Shi Kuang', 'kuangshi@gf.com.cn'],
  ['Goldman Sachs (Asia) LLC', 'Ronald Keung', 'ronald.keung@gs.com'],
  ['Guotai Junan Securities', 'Heping Qin', 'qinheping027734@gtjas.com'],
  ['Haitong International Securities Group Limited', 'Jasmine Bai', 'y.bai@htisec.com'],
  ['Haitong Securities', 'Leina Cao', 'cln13796@haitong.com'],
  ['HSBC', 'Charlene Liu', 'charlene.r.liu@hsbc.com.sg'],
  ['ICBC International Research Limited', 'Zeping Zhao', 'Zeping.zhao@icbci.icbc.com.cn'],
  ['Industrial Securities', 'Jiajun Hong', 'hongjiajun@xyzq.com.cn'],
  ['J.P. Morgan Securities (Asia Pacific) Limited', 'Alex Yao', 'alex.yao@jpmorgan.com'],
  ['Jefferies Hong Kong', 'Thomas Chong', 'thomas.chong@jefferies.com'],
  ['Macquarie Capital', 'Ellie Jiang', 'Ellie.jiang@macquarie.com'],
  ['Morgan Stanley', 'Gary Yu', 'Gary.Yu@morganstanley.com'],
  ['New Street Research', 'Jin K. Yoon', 'jin.yoon@newstreetresearch.com.hk'],
  ['Nomura International (Hong Kong) limited', 'Jialong Shi', 'Jialong.shi@nomura.com'],
  ['Redburn Atlantic', 'Sophie Xiao', 'Sophie.xiao@redburnatlantic.com'],
  ['SWS Research Co.,LTD.', 'Lingyi Zhao', 'zhaoly2@swsresearch.com'],
  ['T.H. Capital Research', 'Tian X. Hou', 'thou@thdatacapital.com'],
].map((analyst) => {
  return {
    coop: analyst[0],
    name: analyst[1],
    email: analyst[2],
  };
});

export default AnalystData;
